const routes = [
  { title: 'Sessions', path: '/sessions' },
  { title: 'Assessments', path: '/assessments' },
  { title: 'Education', path: '/education' },
  { title: 'Library', path: '/library' },
];

export default routes;
